/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseFontSizeEnum } from './DatabaseFontSizeEnum';
import {
    DatabaseFontSizeEnumFromJSON,
    DatabaseFontSizeEnumFromJSONTyped,
    DatabaseFontSizeEnumToJSON,
} from './DatabaseFontSizeEnum';
import type { DatabaseHeaderBlockActionType } from './DatabaseHeaderBlockActionType';
import {
    DatabaseHeaderBlockActionTypeFromJSON,
    DatabaseHeaderBlockActionTypeFromJSONTyped,
    DatabaseHeaderBlockActionTypeToJSON,
} from './DatabaseHeaderBlockActionType';
import type { DatabaseTextHeaderBlock } from './DatabaseTextHeaderBlock';
import {
    DatabaseTextHeaderBlockFromJSON,
    DatabaseTextHeaderBlockFromJSONTyped,
    DatabaseTextHeaderBlockToJSON,
} from './DatabaseTextHeaderBlock';

/**
 * 
 * @export
 * @interface DatabaseNameHeaderBlock
 */
export interface DatabaseNameHeaderBlock extends DatabaseTextHeaderBlock {
}

/**
 * Check if a given object implements the DatabaseNameHeaderBlock interface.
 */
export function instanceOfDatabaseNameHeaderBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseNameHeaderBlockFromJSON(json: any): DatabaseNameHeaderBlock {
    return DatabaseNameHeaderBlockFromJSONTyped(json, false);
}

export function DatabaseNameHeaderBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseNameHeaderBlock {
    return json;
}

export function DatabaseNameHeaderBlockToJSON(value?: DatabaseNameHeaderBlock | null): any {
    return value;
}

